import React from "react";
import styled from "styled-components";
import * as D from "draft-js";

import DraftCss from "./DraftCss";
import * as u from "../utils";
// import TextAreaMention, { mention } from './TextAreaMention';
// import TextAreaSuggest, { suggest } from './TextAreaSuggest';

// const INIT_STATE = D.ContentState.createFromText([
//   'Hey @bes say #hi',
//   'super random stuff',
//   'This is a new line!',
// ].join('\n\n'));

export default function TextAreaRich(props) {
  const currStateRef = React.useRef();
  const currElmRef = React.useRef();
  const decorator = React.useMemo(getDecorator, []);
  const onInitState = () => D.EditorState.createEmpty(decorator);
  // const onInitState = () => D.EditorState.createWithContent(INIT_STATE, decorator);
  const [editorState, setEditorState] = React.useState(onInitState);

  return (
    <S.Container style={props.style} height={props.height}>
      {/*
      <S.DebugContainer>
        <Button onClick={() => onSelect({name: 'TEST'})}>
          Select
        </Button>
      </S.DebugContainer>
      */}
      <DraftCss />
      <D.Editor
        ref={currElmRef}
        editorState={editorState}
        onChange={onChange}
        placeholder={props.placeholder}
      />
    </S.Container>
  );

  function getDecorator() {
    /* ********************************************************
      Commenting this out because we are moth-balling the feature of 'tagging' another user.

      1. It was very difficult to get something similar working on the iOS React Native app
      and we want to keep feature parity between web and native app. 

      2. The value of @mentions as a feature is questionable.

    *************************************************************/
    // return new D.CompositeDecorator([
    //   { component: TextAreaMention, strategy: mention(currStateRef) },
    //   { component: TextAreaSuggest, strategy: suggest(currStateRef), props: { onSelect } },
    // ]);
  }

  function onChange(nextEditorState) {
    currStateRef.current = nextEditorState;
    props.onEditorChange(nextEditorState);
    setEditorState(nextEditorState);
  }

  // function onSelect(user) {

  //   const editorStateRef = currStateRef.current;
  //   const content = editorStateRef.getCurrentContent();
  //   const selection = editorStateRef.getSelection();

  //   const offset = selection.getAnchorOffset() - 1;
  //   const key = selection.getAnchorKey();
  //   const block = content.getBlockForKey(key);
  //   const text = block.getText();

  //   let i = offset; let j = offset;

  //   /* eslint-disable-next-line no-constant-condition */
  //   while(true) {
  //     const iIsFalsy = ((text[i] === ' ') || !text[i]);
  //     const jIsFalsy = ((text[j] === ' ') || !text[j]);
  //     if (iIsFalsy && jIsFalsy) break;
  //     if (!iIsFalsy) i--;
  //     if (!jIsFalsy) j++;
  //   }

  //   const range = selection.merge({anchorOffset: i+1, focusOffset: j, hasFocus: true});
  //   const entity = content.createEntity('MENTION', 'SEGMENTED', {...user});
  //   const entityKey = entity.getLastCreatedEntityKey();

  //   const nextContent = D.Modifier.replaceText(content, range, user.name, null, entityKey);
  //   const nextEditorState = D.EditorState.push(editorStateRef, nextContent, 'apply-entity');
  //   onChange(nextEditorState);
  // }
}

const S = {};

S.Container = styled.div`
  .DraftEditor-root {
    font-family:
      HK Grotesk,
      sans-serif;
    background-color: ${u.colours.white};
    color: ${u.colours.charcoal};
    font-size: 20px;
  }

  .public-DraftEditor-content {
    min-height: ${(p) => p.height ?? 80}px;
  }

  .public-DraftStyleDefault-block {
    font-family:
      HK Grotesk,
      sans-serif;
  }

  .public-DraftEditorPlaceholder-root {
    color: rgb(65, 65, 67, 0.7);
    position: absolute;
    z-index: 0;
  }

  .public-DraftEditorPlaceholder-inner {
    font-family:
      HK Grotesk,
      sans-serif;
  }

  .public-DraftEditorPlaceholder-hasFocus {
    color: rgb(65, 65, 67, 0.7);
  }

  .DraftEditorPlaceholder-hidden {
    display: none;
  }
`;

S.DebugContainer = styled.div`
  z-index: 999;
  position: fixed;
  display: flex;
  padding: 20px;
  border-radius: 10px;
  background: rgb(250, 125, 0);
  top: 20px;
  left: 20px;
`;
